import * as React from 'react';
import { cx } from '@/lib/utils/cn';

/**
 * Quote — what someone said, in their words (`.quote` in
 * `docs/requirement-library/prototype/selection.css`): a 2px ink-200
 * rule on the left and curly quotes. `struck` is the withdrawn look
 * (`.said-row.gone .quote` in the discovery prototype): the text stays,
 * struck through, so the record is never hidden.
 */
export function Quote({
  children,
  size = 'md',
  struck = false,
  className,
}: {
  children: React.ReactNode;
  size?: 'sm' | 'md';
  struck?: boolean;
  className?: string;
}) {
  return (
    <p
      className={cx(
        'border-l-2 border-ink-200 pl-3',
        size === 'sm' ? 'text-body-sm' : 'text-body',
        struck ? 'text-ink-300 line-through' : 'text-ink-900',
        className,
      )}
    >
      &ldquo;{children}&rdquo;
    </p>
  );
}
